import { render } from "./App.vue?vue&type=template&id=40d88d96"
const script = {}

import "./App.vue?vue&type=style&index=0&id=40d88d96&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__